import {
    TableCell,
    TableRow,
} from "@mui/material";
import WRONG from "../../assets/wrong.svg";
import ADD from "../../assets/add.svg";
import EDIT from "../../assets/edit.svg";
import DELETE from "../../assets/bin.svg";
import { qty } from "./elemant/Columns";


export const row_style = {
    fontSize: "1em",
    padding: "0.8em",
    textAlign: "center",
}

export const sr_style = {
    fontSize: "1em",
    padding: "0.8em",
    textAlign: "center",
    width: "7.5%",
}

export const buttonObject= {
    fontSize: "1em !important",
    padding: "0.8em !important",
    textAlign: "center !important",
    width: "25% !important",
}

export function getErrroRow(row) {
    if (row.score < 100 || qty.includes(row.quantity)) {
        return { backgroundColor: "#FFECEC" };
    } else {
        return {};
    }
}

const ReconslationTableView = ({
    row,
    setData,
    setEditState,
    setEditRowBakup,
    index,
    disabledState,
    setDisabledState
}) => {
    
    const addRowHandler = (row, index) => {
        setData((prevData) => {
            const newData = [...prevData];
            newData.splice(index + 1, 0, {
                description: '',
                batch_number: '',
                quantity: 1,
                page_no: row.page_no,
                score: 100,
                sr_no: row.sr_no + 1,
            })
            newData.forEach((item, idx) => {
                item.sr_no = idx + 1;
            });
            return newData;
        });
        setEditState(row.sr_no + 1)
        setEditRowBakup({})
        setDisabledState(true)
    }

    const editHandler = (row) => {
        setEditRowBakup(row)
        setEditState(row.sr_no)
        setDisabledState(true)
    }
    const deleteHandler = (idx) => {
        setData((prevData) => {
            const newData = prevData.filter((item, itemIdx) => {
                // Filter out the item based on the row ID or any other condition
                return idx !== itemIdx;
            });
    
            // Update sr_no values in the filtered data
            newData.forEach((item, idx) => {
                item.sr_no = idx + 1;
            });
    
            return newData;
        });
    }

    return (
    <TableRow key={row.sr_no} style={getErrroRow(row)}>
        <TableCell style={sr_style}>{
        <span className="reconcilation__verification__qty_error">
            {row.quantity === 0 && <img src={WRONG} alt="WRONG_QTY_ERROR" />}
            {row.sr_no}
        </span>
        }</TableCell>
        <TableCell style={row_style}>{row.description}</TableCell>
        <TableCell style={row_style}>{row.batch_number}</TableCell>
        <TableCell style={row_style}>{row.quantity}</TableCell>
        <TableCell style={buttonObject}>
        <button 
            onClick={() => addRowHandler(row, index)}
            className="reconcilation__verification__table_action"
            disabled={disabledState}
        >
            <img src={ADD} alt="ADD ROW" />
        </button>
        <button
            onClick={() => {editHandler(row)}}
            className="reconcilation__verification__table_action"
            disabled={disabledState}
        >
            <img src={EDIT} alt="SAVE" />
        </button>
        <button
            onClick={() => deleteHandler(index)}
            className="reconcilation__verification__table_action"
            disabled={disabledState}
        >
            <img src={DELETE} width="9px" alt="cancel" />
        </button>
        </TableCell>
    </TableRow>
    )
}

export default ReconslationTableView